export var ERequestStatus = /*#__PURE__*/function (ERequestStatus) {
  ERequestStatus["Failure"] = "failure";
  ERequestStatus["Initial"] = "initial";
  ERequestStatus["Loading"] = "loading";
  ERequestStatus["Success"] = "success";
  return ERequestStatus;
}({});